import type RouterService from '@ember/routing/router-service';
import type { NavigateFunction } from '../types';

export function createEmberNavigateFn(router: RouterService): NavigateFunction {
  return (to, options) => {
    const url = new URL(typeof to === 'string' ? to : (to.pathname ?? ''), window.location.origin);

    if (typeof to !== 'string') {
      url.search = new URLSearchParams(to.search).toString();
    }

    const routerMethod = options?.replace ? 'replaceWith' : 'transitionTo';

    router[routerMethod](`${url.pathname}${url.search}`);
  };
}
